module.exports = __webpack_public_path__ + "img/guide06.270810a3.jpg";